module.exports = require("core-js/library/fn/parse-float");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/parse-float.js
// module id = jAqF
// module chunks = 0